import { takeEvery, put, fork, call, all, select } from 'redux-saga/effects';
import * as ds from './dashboardSlice';
import * as uis from '../../UI/redux/uiSlice';
import { authReducerActions, authSagaActions } from '../../Auth';
import { getDailyStatistics, getMonthlyReceipts, getMonthlyTransactions, getMonthlyRevenue } from './dashboardAPI';

export function* onLoadDailyStatisticsStartAsync({ payload }){

    try {

        yield put(ds.actions.startCall({ callType: ds.callTypes.list }));

        const getAuth = (state) => state.auth;
        const auth = yield select(getAuth);

        if(!auth.userName || !auth.sessionKey){
            yield put(authSagaActions.logout());
            return
        }

        let reqBody = {
            username: auth.userName,
            key: auth.sessionKey
        };
        
        const response = yield call(getDailyStatistics, payload.deptId, reqBody);
        if(response.status === 200){
            
            let dailyStats = response.data;
            
            yield put(ds.actions.dailyStatsFetched({ dailyStats }));

        }
    }
    catch(error){

        console.log(error);

        if(error.response.status === 403 || error.response.status === 400){
            yield put(authReducerActions.loggedOut());
        } else {
            if(error.response.status === 404){
                let status = error.response.status;
                let msg = "Page Not Found.";
                yield put(uis.actions.error({ status, msg }));
            } else if(error.response.status === 500){
                let status = error.response.status;
                let msg = "Internal Error";
                yield put(uis.actions.error({ status, msg }));
            }

            yield put(uis.actions.showNotification({
                status: "error",
                title: "Error",
                message: "There was an error retrieving the daily statistics data."
            }));

            yield put(ds.actions.catchError({
                callType: ds.callTypes.list,
                error: "There was an error retrieving the daily statistics data."
            }));
        }
    }
};

export function* onLoadMonthlyTransactionsStartAsync({ payload }) {
    try {

        yield put(ds.actions.startCall({ callType: ds.callTypes.list }));

        const getAuth = (state) => state.auth;
        const auth = yield select(getAuth);

        if(!auth.userName || !auth.sessionKey){
            yield put(authSagaActions.logout());
            return
        }

        let reqBody = {
            username: auth.userName,
            key: auth.sessionKey
        };

        const response = yield call(getMonthlyTransactions, payload.deptId, reqBody);        

        if(response.status === 200){
            let monthlyTrans = response.data;
            yield put(ds.actions.monthlyTransFetched({ monthlyTrans }));
        }

    }
    catch (error){

        console.log(error);

        if(error.response.status === 403 || error.response.status === 400){
            yield put(authReducerActions.loggedOut());
        } else {
            if(error.response.status === 404){
                let status = error.response.status;
                let msg = "Page Not Found.";
                yield put(uis.actions.error({ status, msg }));
            } else if(error.response.status === 500){
                let status = error.response.status;
                let msg = "Internal Error";
                yield put(uis.actions.error({ status, msg }));
            }

            yield put(uis.actions.showNotification({
                status: "error",
                title: "Error",
                message: "There was an error retrieving the monthly transactions."
            }));

            yield put(ds.actions.catchError({
                callType: ds.callTypes.list,
                error: "There was an error retrieving the monthly transactions."
            }));
        }
    }
};

export function* onLoadMonthlyRevenueStartAsync({ payload }) {
    try {

        yield put(ds.actions.startCall({ callType: ds.callTypes.list }));

        const getAuth = (state) => state.auth;
        const auth = yield select(getAuth);

        if(!auth.userName || !auth.sessionKey){
            yield put(authSagaActions.logout());
            return
        }

        let reqBody = {
            username: auth.userName,
            key: auth.sessionKey
        };

        const response = yield call(getMonthlyRevenue, payload.deptId, reqBody);        

        if(response.status === 200){
            let monthlyRev = response.data;
            yield put(ds.actions.monthlyRevFetched({ monthlyRev }));
        }

    }
    catch (error){

        console.log(error);

        if(error.response.status === 403 || error.response.status === 400){
            yield put(authReducerActions.loggedOut());
        } else {
            if(error.response.status === 404){
                let status = error.response.status;
                let msg = "Page Not Found.";
                yield put(uis.actions.error({ status, msg }));
            } else if(error.response.status === 500){
                let status = error.response.status;
                let msg = "Internal Error";
                yield put(uis.actions.error({ status, msg }));
            }

            yield put(uis.actions.showNotification({
                status: "error",
                title: "Error",
                message: "There was an error retrieving the monthly revenues."
            }));

            yield put(ds.actions.catchError({
                callType: ds.callTypes.list,
                error: "There was an error retrieving the monthly revenues."
            }));
        }
    }
};

export function* onLoadMonthlyReceiptsStartAsync({ payload }) {
    try {

        yield put(ds.actions.startCall({ callType: ds.callTypes.list }));

        const getAuth = (state) => state.auth;
        const auth = yield select(getAuth);

        if(!auth.userName || !auth.sessionKey){
            yield put(authSagaActions.logout());
            return
        }

        let reqBody = {
            username: auth.userName,
            key: auth.sessionKey
        };

        const response = yield call(getMonthlyReceipts, payload.deptId, reqBody);        

        if(response.status === 200){
            let monthlyRec = response.data;
            yield put(ds.actions.monthlyRecFetched({ monthlyRec }));
        }

    }
    catch (error){

        console.log(error);

        if(error.response.status === 403){
            yield put(authReducerActions.loggedOut());
        } else {
            if(error.response.status === 404){
                let status = error.response.status;
                let msg = "Page Not Found.";
                yield put(uis.actions.error({ status, msg }));
            } else if(error.response.status === 500){
                let status = error.response.status;
                let msg = "Internal Error";
                yield put(uis.actions.error({ status, msg }));
            }

            yield put(uis.actions.showNotification({
                status: "error",
                title: "Error",
                message: "There was an error retrieving the monthly receipts."
            }));

            yield put(ds.actions.catchError({
                callType: ds.callTypes.list,
                error: "There was an error retrieving the monthly receipts."
            }));
        }
    }
};

export const actionTypes = {
    FetchDailyStats: "[DailyStatsFetched] Fetch Agency Dashboard Date API Action",
    FetchMonthlyTrans: "[MonthlyTransUpdate] Fetch Agency Monthly Transaction API Action",
    FetchMonthlyRevenue: "[MonthlyRevenueFetched] Fetch Agency Monthly Revenue API Action",
    FetchMonthlyReceipts: "[MonthlyReceiptsFetched] Fetch Agency Monthly Receipts API Action",
};

export const actions = {

    fetchDailyStats: (deptId) => ({ type: actionTypes.FetchDailyStats, payload: { deptId }}),
    fetchMonthlyTrans: (deptId) => ({ type: actionTypes.FetchMonthlyTrans, payload: { deptId } }),
    fetchMonthlyRevenue: (deptId) => ({ type: actionTypes.FetchMonthlyRevenue, payload: { deptId }}),
    fetchMonthlyReceipts: (deptId) => ({ type: actionTypes.FetchMonthlyReceipts, payload: { deptId } })
};

export function* fetchDailyStats() {
    
    yield takeEvery(actionTypes.FetchDailyStats, onLoadDailyStatisticsStartAsync);
};

export function* fetchMonthlyTrans() {

    yield takeEvery(actionTypes.FetchMonthlyTrans, onLoadMonthlyTransactionsStartAsync);
};

export function* fetchMonthlyRevenue() {

    yield takeEvery(actionTypes.FetchMonthlyRevenue, onLoadMonthlyRevenueStartAsync);
};

export function* fetchMonthlyReceipts() {

    yield takeEvery(actionTypes.FetchMonthlyReceipts, onLoadMonthlyReceiptsStartAsync);
};

const dsSagas = [
    fork(fetchDailyStats),
    fork(fetchMonthlyTrans),
    fork(fetchMonthlyRevenue),
    fork(fetchMonthlyReceipts)
];

export function* saga(){
    yield all([...dsSagas]);
};